import { UserDetails } from './user-details.model';
import { BaseUserResult } from '../../base-user-result';


export class UserDetailResult extends BaseUserResult {
  public userdetails: UserDetails;

  constructor(ok: boolean, status: number, statusText: string, userDetails: UserDetails) {
    super(ok, status, statusText);
    this.userdetails = userDetails;
  }

  get UserDetails(): UserDetails {
    return this.userdetails;
  }
}

